import { defineKey as T } from 'ha/i18n';

export const STATE_NAME = 'inbox';
export const ACTIONS_PREFIX = 'Inbox';
export const PAGE_SIZE = 10;
export const PAGER_WIDTH = 9;
export const LISTINGS_THUMB = '81x81';

export enum Kinds {
  INBOX = 'inbox',
  PENDING = 'pending',
  FAVORITE = 'favorited',
  ARCHIVED = 'archived',
  PAID = 'paid',
  EXPIRED = 'expired',
  ALL = 'all',
  UNREAD = 'unread',
}

export const KindFilterGroups = {
  main: [
    {
      type: Kinds.INBOX,
      title: T('Inbox'),
      icon: 'inbox',
      category: 'inbox',
    },
    {
      type: Kinds.FAVORITE,
      title: T('Shortlist'),
      icon: 'thumbs-up',
      category: 'favorited',
    },
    {
      type: Kinds.ARCHIVED,
      title: T('Archive'),
      icon: 'thumbs-down',
      category: 'archived',
    },
  ],
  secondary: [
    {
      type: Kinds.PENDING,
      title: T('Pending'),
      icon: 'hourglass-half',
      category: 'pending',
    },
    {
      type: Kinds.PAID,
      title: T('Booking'),
      icon: 'calendar-check-o',
      category: 'paid',
    },
    {
      type: Kinds.EXPIRED,
      title: T('Expired'),
      icon: 'clock-o',
      category: 'expired',
    },
  ],
  rest: [
    {
      type: Kinds.ALL,
      title: T('All'),
      icon: 'list',
      category: 'all',
    },
    {
      type: Kinds.UNREAD,
      title: T('Unread'),
      icon: 'envelope',
      category: 'allUnread',
    },
  ],
};
